import React, { type HTMLAttributeAnchorTarget } from 'react';

export type ExternalLinkProps = {
    href: string;
    target?: HTMLAttributeAnchorTarget;

    text?: string;
    children?: ReactNode;
};

export function ExternalLink({ href, target, text, children }: ExternalLinkProps) {
    // eslint-disable-next-line gatsby/use-gatsby-link
    return <a href={href} target={target || '_blank'} rel="noopener noreferrer" children={text || children || href} />;
}
